/*
 * @Descripttion: API接口的统一出口
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-25 11:31:45
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-12-14 15:53:52
 */
import { MD5 } from "crypto-js";
import { base } from "./base";
import http from "utils/http";
import store from "../store";
import axios from "axios";
import { Base64 } from "../js/base64js";

// 公共接口
const common = {
  // 获取accessToken
  getAccessToken(params){
    const timestamp = new Date().getTime();
    const client_secret = "p24zsnjjc9595aeles8j5xef0jexit425vv8o6xo";
    const sign = MD5(`${timestamp}&grant_type=${params.grant_type}&client_id=${params.client_id}&client_secret=${client_secret}&${timestamp}`);
    return http.post(
      `${base.request}/auth/getAccessToken?grant_type=${params.grant_type}&client_id=${params.client_id}&timestamp=${timestamp}&sign=${sign}`,
    );
  },
  // 获取微服务的accessToken
  // getWFWAccessToken(){
  //  return http.post(
  //     `${base.bsRequest}/api-oauth/oauth/token?grant_type=client_credentials`,{},"weifuwu"
  //   );
  // },
  //获取微信分享所需的配置字段
  getWxShareSignature(params){
    return http.get(`${base.request}/platform/usersUser/getWxShareSignature`,params)
  }
};
// // 登录验证
const login = {
  getSmsCode(params){
    return http.get(
      `${base.request}/platform/usersUser/getSmsCode`,
      params
    );
  },
  // 注册
  register(params){
    return http.post(
      `${base.request}/platform/usersUser/register`,
      params
    );
  },
  // 登录
  login(params) {
    return http.post(
      `${base.request}/auth/loginApp`,
      params
    );
  },
  retrievePassword(params) {
    return http.post(
      `${base.request}/platform/usersUser/retrievePassword`,
      params
    );
  },
  getUserInfo() {
    return http.get(`${base.request}/platform/usersUser/getUserInfo`)
  },
  //微信登录-通过code换取网页授权access_token
  getOpenIdByCode(params) {
    return http.get(`${base.request}/platform/usersUser/getOpenIdByCode`,params)
  },
  //token过期-刷新token
  refreshToken(){
    const { refreshToken } = store.state;
    return axios.post(`${base.request}/auth/refresh`,{},{
      headers:{
        Authorization: refreshToken
      }
    })
    // return http.post(`${base.request}/auth/refresh`)
  }
  
  
};
const spark = {
  // 添加话题
  insertTopic(params={}) {
    Object.assign(params,globalParams())
    return http.post(
      `${base.request}/njwst/wst/topic/insert`,
      params
    );
  },
  // 添加问题回答记录
  addQuestion(params={}) {
    Object.assign(params,globalParams());
    return http.post(
      `${base.request}/njwst/wst/question/add`,
      params
    );
  },
  //游客询问问题数量
  getQuestionCount(){
    const { visitorTag } = globalParams();
    return http.get(
      `${base.request}/njwst/wst/question/getCount`,
      {visitorTag}
    );
  },
  //实时语音转写
  audioRtasr(params){
    // const { wfwAccessToken } = store.state;
    return http.post(
      `${base.request}/njwst/wst/audio/iat`,
      // `${base.bsRequest}/api-ai/audio/iat?access_token=${wfwAccessToken}`,
      params,
      // "weifuwu"
    );
  },
  // 话题最后一条数据
  getLastTopic(params={}) {
    Object.assign(params,globalParams());
    return http.post(
      `${base.request}/njwst/wst/topic/getLast`,
      params,
    );
  },
  // 获取话题列表
  getTopicList(params){
    Object.assign(params,globalParams());
    return http.get(
      `${base.request}/njwst/wst/topic/list`,
      params,
    );
  },
  //根据话题id查询问题回答记录列表
  getQuestionList(params){
    Object.assign(params,globalParams());
    return http.get(
      `${base.request}/njwst/wst/question/list`,
      params,
    );
  },
  // 获取信息反馈列表数据
  getInformationList(params = {}){
    Object.assign(params,globalParams());
    return http.get(
      `${base.request}/njwst/wst/question/getInformationList`,
      params,
    );
  },
  // 点赞/取消点赞
  likeOrStopLike(params){
    Object.assign(params,globalParams());
    return http.post(
      `${base.request}/njwst/wst/question/stopLike`,
      params,
    );
  },
  // 踩/取消踩
  stepOrStopStep(params){
    Object.assign(params,globalParams());
    return http.post(
      `${base.request}/njwst/wst/question/stopStep`,
      params,
    );
  },
  // 反馈问题提交
  saveInfromation(params){
    Object.assign(params,globalParams());
    return http.post(
      `${base.request}/njwst/wst/question/saveInfromation`,
      params,
    );
  },
  // 关键词点击
  keyworkClickNumber(params){
    Object.assign(params,globalParams());
    return http.get(
      `${base.request}/njwst/keyword/clickNumber`,
      params,
    );
  }
  
  
}
const globalParams = () =>{
  // const userInfo = localStorage.getItem("userInfo")
  const userInfo = store.state.userInfo;
  let visitorTag = localStorage.getItem("visitorTag");
  if(userInfo && Object.keys(userInfo).length){
   return {
      platformUserCode:userInfo.platformUserCode,  //统一用户中心id，登录后才有
      userId: userInfo.id,   //用户id，登录后才有
    }
  } else {
    if(!visitorTag){
      visitorTag = `${navigator.userAgent}${new Date().getTime()}`;
      localStorage.setItem("visitorTag",visitorTag);
    }
    return {
      visitorTag  //游客标识，未登录时传
    }
  }
  
}
export default {
  login,
  common,
  spark
};
